'use strict';
// jQuery extensions

module.exports = function () {
    // params
    // toggleClass - required
    // triggerSelector - optional. the selector for the element that triggers the event handler. defaults to the child elements of the list.
    // eventName - optional. defaults to 'click'
    $.fn.toggledList = function (options) {
        if (!options.toggleClass) { return this; }
        var list = this;
        return list.on(options.eventName || 'click', options.triggerSelector || list.children(), function (e) {
            e.preventDefault();
            var classTarget = options.triggerSelector ? $(this).parent() : $(this);
            classTarget.toggleClass(options.toggleClass);
            // execute callback if exists
            if (options.callback) { options.callback(); }
        });
    };

    $.fn.syncHeight = function () {
        var arr = $.makeArray(this);
        arr.sort(function (a, b) {
            return $(a).height() - $(b).height();
        });
        return this.height($(arr[arr.length - 1]).height());
    };

    /**
     * @description Scrolls <body> element to a current element with a given offset
     * @param offset
     * @param duration
     */
    $.fn.scrollTo = function(offset = 0, duration = 1) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $(this).offset().top + offset
        }, duration);
    };

    // making "touchmove" event of "searchOverlayOpened" namespace to be not passive
    // (to be able to prevent it's default behaviour)
    $.event.special.touchmove = {
        setup: function(_, ns, handle) {
            if (ns && ns.indexOf('searchOverlayOpened') !== -1) {
                this.addEventListener('touchmove', handle, { passive: false });
            } else {
                this.addEventListener('touchmove', handle, { passive: true });
            }
        }
    };
};
